import React, { useEffect } from "react";
import { Spin } from "../../BP2Components";
import VisibilitySensor from "react-visibility-sensor";
import SingleCase from "../../FormsV2/CasesList/SingleCase/SingleCase";
import { setBackUrl } from "../../../appRedux/actions/Auth";
import { useDispatch } from "react-redux";
import IntlMessages from "../../../util/IntlMessages";
import allItemsIcon from "../../../assets/infinityListAssets/allItems.svg";
import unreadItemsIcon from "../../../assets/infinityListAssets/unreadItems.svg";
import plannedItemsIcon from "../../../assets/infinityListAssets/plannedItems.svg";

interface InfiniteListContentProps {
   casesList?: any;
   listResponse: any;
   isLoading: boolean;
   getCases?: (val: number) => void;
   setPageToDownload?: (val: number) => void;
   isProfilesAdded: boolean;
   handleVisibilityChange: (isVisible: boolean, singleCase: any) => void;
   actionCallback: () => void;
   value: any;
   stats: {
      "system.api.cases.stats.not_planned": number;
      "system.api.cases.stats.planned": number;
      "system.api.cases.stats.read": number;
      "system.api.cases.stats.not_read": number;
      "system.api.cases.stats.all": number;
   };
}

const InfiniteListContent: React.FC<InfiniteListContentProps> = ({
   casesList,
   getCases,
   setPageToDownload,
   listResponse,
   isLoading,
   isProfilesAdded,
   handleVisibilityChange,
   actionCallback,
   value,
   stats,
}) => {
   const dispatch = useDispatch();

   useEffect(() => {
      dispatch(setBackUrl(window.location.href));
   }, []);

   return (
      <div style={{ position: "relative", height: "100%" }}>
         <div className="infinity-case-item-count-bar">
            <div className="infinity-case-item-count-bar__item">
               <img className="image" src={allItemsIcon} />
               <IntlMessages id="infinity.totalItemsCount" />:
               <span className="ammout">{stats?.["system.api.cases.stats.all"] || 0}</span>
            </div>
            <div className="infinity-case-item-count-bar__item">
               <img className="image" src={unreadItemsIcon} />
               <IntlMessages id="infinity.totalUnreadedItems" />:
               <span className="ammout">{stats?.["system.api.cases.stats.not_read"] || 0}</span>
            </div>
            <div className="infinity-case-item-count-bar__item">
               <img className="image" src={plannedItemsIcon} />
               <IntlMessages id="infinity.totalPlannedItems" />:
               <span className="ammout">{stats?.["system.api.cases.stats.planned"] || 0}</span>
            </div>
         </div>
         <div
            className="major-infinite-list-widget"
            style={isProfilesAdded ? { pointerEvents: "none" } : {}}
         >
            {!isProfilesAdded &&
               casesList?.map((singleCase) => (
                  <VisibilitySensor
                     key={singleCase.Id}
                     onChange={(isVisible) => handleVisibilityChange(isVisible, singleCase)}
                  >
                     <div className="single-case-in-infinite-list">
                        <SingleCase
                           getCases={getCases}
                           setPageToDownload={setPageToDownload}
                           value={value}
                           singleCase={singleCase}
                           //@ts-ignore TODO: make list response interface
                           listResponse={listResponse?.data?.default}
                           actionCallback={actionCallback}
                        />
                     </div>
                  </VisibilitySensor>
               ))}
            {isLoading && <Spin />}
         </div>
      </div>
   );
};

export default InfiniteListContent;
